import React, {useState, useEffect} from "react";

export const ContactSection = () => {
    const isVisible = (elementOffset) => {
        return scrollY > elementOffset - window.innerHeight + 100;
    };

    return (
        <section id="contact-us" className="py-20 bg-gradient-to-t from-[#FF4D00]/10 to-transparent bg-zinc-900">
            <div className="max-w-4xl mx-auto px-4">
                <div
                    className={`transform transition-all duration-1000 ${
                        isVisible(1800)
                            ? "opacity-100 translate-y-0"
                            : "opacity-0 translate-y-10"
                    }`}
                >
                    <div className="text-center mb-12">
                        <h2 className="text-3xl/[1.5] font-bold mb-6 text-[#FF4D00]">
                            Ready to elevate your festival experience?
                        </h2>
                        <p className="text-xl text-gray-300">
                            Join the growing number of festivals using Helga Festival App and raise your festival to the next level!
                        </p>
                    </div>

                    <div className="bg-white/5 p-12 rounded-xl backdrop-blur-sm border border-[#FF4D00]/10 container px-6 py-12 mx-auto">
                        <div className="text-center">
                            <h3 className="text-xl font-semibold mb-4 text-[#FF4D00]">
                                Get in touch directly
                            </h3>
                            <p className="text-gray-300">Shoot us an email and let us know who you are, which festival you represent and that you are interested.</p>
                            <p >That's all! We'll get in touch and give you a full tour!</p>
                        </div>

                        <div className="grid grid-cols-1 gap-4 mt-10 text-center">

                            {/* Matt */}
                            <div className="grid grid-cols-1 gap-12 md:grid-cols-2 mx-auto">
                                <div className=" inline-block p-3 gap-4 ">
                                    <img className="w-36 h-36 rounded-full" src={require("../assets/matt.jpg")}
                                         alt="Matthew"/>
                                    <div className="font-medium dark:text-white">
                                        <div>Matthew Jorgensen</div>
                                        <div className="text-sm text-gray-500 dark:text-gray-400">Head of sales US</div>
                                    </div>
                                </div>
                                {/* Chrissy */}
                                <div className="inline-block p-3 gap-4 mx-auto ">
                                    <img className="w-36 h-36 rounded-full" src={require("../assets/christina.jpg")}
                                         alt="Matthew"/>
                                    <div className="font-medium dark:text-white">
                                        <div>Christina Jorgensen</div>
                                        <div className="text-sm text-gray-500 dark:text-gray-400">Head of sales EU</div>
                                    </div>
                                </div>
                            </div>
                            <a
                                href="mailto:contact@helga-app.com"
                                className="text-[#FF4D00] hover:text-[#FF6B00] transition block"
                            >
                                contact@helga-app.com
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
        ;
};
